/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const AddressValidationOutcome = {
    Validated: 'Validated',
    MultipleMatches: 'MultipleMatches',
    NotUnique: 'NotUnique',
    NotFound: 'NotFound',
} as const;
export type AddressValidationOutcome = typeof AddressValidationOutcome[keyof typeof AddressValidationOutcome];

